import { FloatingDelayGroup } from '@floating-ui/react';
import React, { HTMLAttributes } from 'react';

export interface VoxelDataTableRowProps extends HTMLAttributes<HTMLTableRowElement> {}

export const VoxelDataTableRow = React.forwardRef<HTMLTableRowElement, VoxelDataTableRowProps>(
  ({ className, ...props }, ref) => {
    return (
      <FloatingDelayGroup delay={{ open: 700, close: 300 }}>
        <tr className={`${className}`} {...props} ref={ref} />
      </FloatingDelayGroup>
    );
  }
);

export default VoxelDataTableRow;
